/* eslint-disable no-console */
<template>
    <div>
        <div class="header_unit header_bg_white">
            <div class="header_box">
                <div class="menu_left">
                    <router-link class="icn_back_black top_tit" :to="{ name: 'manageCommpanyBrandList' , params:{brandPath :this.$route.params.brandPath}} ">
                        <p class="top_tit">＜戻る</p></router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_l top_tit">企業詳細</p>
                </div>
            </div>
        </div>
        <CommpanyBrandDitail :id="this.id"/>
    </div>
</template>

<script>
    import CommpanyBrandDitail from '@/app/components/CommpanyBrandDetail.vue'
    export default {
        name: 'manageCommpanyBrandDetail',
        components: {
            CommpanyBrandDitail
        },
        props:{
            id:Number,
        },
    }
</script>
